/*
 * supabase (service)
 */
import { createClient } from "@supabase/supabase-js"

if (
	!import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY &&
	!process.env.VITE_SUPABASE_PUBLISHABLE_KEY
) {
	alert("VITE_SUPABASE_PUBLISHABLE_KEY is required")
	throw new Error("VITE_SUPABASE_PUBLISHABLE_KEY is required")
}
if (!import.meta.env.VITE_SUPABASE_URL && !process.env.VITE_SUPABASE_URL) {
	alert("VITE_SUPABASE_URL is required")
	throw new Error("VITE_SUPABASE_URL is required")
}

const SUPABASE_PUBLISHABLE_KEY =
	import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY ||
	process.env.VITE_SUPABASE_PUBLISHABLE_KEY
const SUPABASE_URL =
	import.meta.env.VITE_SUPABASE_URL || process.env.VITE_SUPABASE_URL

const supabase = createClient(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY)

export default supabase
